<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('bisep_applications')"
                        :isColumns="true"
                        :is-new-button="true"
                        @new-button-click="openAddModal"
                        @filter-div-status="datatable.filterStatus=$event"
                >
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('bisep_applications')"
                              :isColumns="true"
                              @filter-div-status="datatable.filterStatus=$event"
                >
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns" :key="key">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </HeaderMobile>
            </template>
            <datatable-filter
                v-show="datatable.filterStatus"
                :export-excel="true"
                @exportExcel="excelExport"
                @filter="filter"
                @filterClear="filterClear">
                <b-row>
                    <b-col md="3">
                        <b-form-group :label="$t('national_id')">
                            <b-form-input type="text" v-model="datatable.queryParams.filter.national_id"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group :label="$t('name')">
                            <b-form-input type="text" v-model="datatable.queryParams.filter.name"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group :label="$t('surname')">
                            <b-form-input type="text" v-model="datatable.queryParams.filter.surname"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group :label="$t('period')">
                            <semesters-selectbox v-model="datatable.queryParams.filter.semester_id"
                                                 :multiple="false"/>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group :label="$t('email')">
                            <b-form-input type="text" v-model="datatable.queryParams.filter.email"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group :label="$t('gsm_no')">
                            <b-form-input type="text" v-model="datatable.queryParams.filter.mobile_tel"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group :label="$t('city')">
                            <city-selectbox v-model="datatable.queryParams.filter.city"  />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group :label="$t('district')">
                            <district-outline-selectbox v-model="datatable.queryParams.filter.district"
                                                        :city_id="datatable.queryParams.filter.city" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group :label="$t('class')">
                            <ParameterSelectbox code="bisep_application.high_school_classes" v-model="datatable.queryParams.filter.class"/>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group :label="$t('application_group')">
                            <multi-selectbox v-model="datatable.queryParams.filter.group"
                                             :options="groupOptions"
                                             :multiple="false"/>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group :label="$t('start_date')">
                            <select-date v-model="datatable.queryParams.filter.start_date" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group :label="$t('end_date')">
                            <select-date v-model="datatable.queryParams.filter.end_date" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group :label="$t('status')">
                            <multi-selectbox v-model="datatable.queryParams.filter.status"
                                             :options="statusOptions"
                                             :multiple="false"/>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            >
            </datatable>
            <CommonModal ref="updateModal" size="xxl"  :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    <div>{{ updateTitle }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <update-form
                        :formId="formId"
                        :update-mode="updateMode"
                        @updated="afterUpdate"
                        @updatedMsg="afterUpdateMsg"
                        :goTab="goTabIndex"
                        v-if="formProcess==='updateModal'"></update-form>
                </template>
            </CommonModal>
            <CommonModal ref="addModal" size="xxl"  :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    <div>{{ $t('add_new') }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <StoreForm v-if="formProcess==='addModal'"></StoreForm>
                </template>
            </CommonModal>
            <CommonModal ref="bulkMessageModal" size="xl">
                <template v-slot:CommonModalTitle>
                    <div>{{ $t('message_bulk_title') }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <div>
                        <ValidationObserver ref="bulkMessageFormValidate">
                            <b-alert show variant="secondary">
                                <b-row>
                                    <b-col cols="12" class="mb-2">
                                        <b-badge>{{ $t('message_bulk_to') }}</b-badge>
                                    </b-col>
                                    <b-col cols="9" md="10">
                                        <ValidationProvider name="message" rules="required" v-slot="{errors}">
                                            <b-form-group>
                                                <b-form-textarea v-model="bulkMsgForm.message"
                                                                 :class="errors[0] ? 'is-invalid':''"
                                                                 rows="3"
                                                                 :placeholder="$t('message')"
                                                />
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="3" md="2">
                                        <b-button block variant="primary" @click="bulkMessageSend">
                                            {{$t('send')}}
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-alert>
                        </ValidationObserver>
                    </div>
                </template>
            </CommonModal>
            <CommonModal id="importFormModal" size="lg" :onHideOnlyX="true">
                <template v-slot:CommonModalTitle>
                    {{ importModalTitle }}
                </template>
                <template v-slot:CommonModalContent>
                    <b-row>
                        <b-col cols="12" md="10">
                            <ValidationObserver ref="importFormValidate">
                                <ValidationProvider name="file" rules="required" v-slot="{errors}">
                                    <b-input-group class="mb-0">
                                        <b-form-file v-model="importFile"
                                                     :placeholder="$t('upload_file')"
                                                     :state="errors[0] ? false : null"
                                                     ref="fileInput2"
                                        />
                                        <b-input-group-append>
                                            <b-button variant="outline-secondary" @click="$refs.fileInput2.$el.childNodes[0].click()">{{ $t('browse') }}</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                </ValidationProvider>
                            </ValidationObserver>
                        </b-col>
                        <b-col cols="12" md="2" class="d-flex justify-content-end">
                            <b-button variant="primary" @click="uploadFile">{{ $t('upload') }}</b-button>
                        </b-col>
                    </b-row>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    // Template
    import AppLayout from '@/layouts/AppLayout'
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    // Components
    import DatatableFilter from '@/components/datatable/DatatableFilter'
    import Datatable from '@/components/datatable/Datatable'
    import MultiSelectbox from '@/components/interactive-fields/MultiSelectbox'
    import CommonModal from '@/components/elements/CommonModal'
    import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox"
    import CitySelectbox from "@/components/interactive-fields/CitySelectbox"
    import DistrictOutlineSelectbox from "@/components/interactive-fields/DistrictOutlineSelectbox"
    import SelectDate from "@/components/interactive-fields/SelectDate"

    // Pages
    import UpdateForm from './UpdateForm'

    // Services
    import BisepService from "@/services/BisepService"

    // Others
    import qs from 'qs'
    import { ValidationObserver, ValidationProvider } from 'vee-validate'
    import StoreForm from "@/modules/bisepApplication/pages/admin/StoreForm.vue";


    export default {
        components: {
            StoreForm,
            AppLayout,
            Header,
            HeaderMobile,
            ValidationProvider,
            ValidationObserver,

            MultiSelectbox,
            CommonModal,
            SemestersSelectbox,
            SelectDate,
            DistrictOutlineSelectbox,
            CitySelectbox,

            UpdateForm,
            DatatableFilter,
            Datatable,
        },
        metaInfo() {
            return {
                title: this.$t('bisep_applications')
            }
        },
        data() {
            return {
                formProcess:null,
                nationalId: '',
                formId:null,
                datatable: {
                    actions: [],
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            sortable: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('view')+'/'+this.$t('edit'),
                                    class: 'ri-edit-box-line align-middle top-minus-1 mr-3 text-muted',
                                    callback: (row) => {
                                        this.openUpdateModal(row, true, 0)
                                    },
                                    permission:"bisepapplication_update"
                                },
                                {
                                    text: this.$t('references'),
                                    class: 'ri-user-line align-middle top-minus-1 mr-3 text-muted',
                                    callback: (row) => {
                                        this.openUpdateModal(row, true, 2)
                                    },
                                    permission:"bisepapplicationreference_index"
                                },
                                {
                                    text: this.$t('documents'),
                                    class: 'ri-file-list-line align-middle top-minus-1 mr-3 text-muted',
                                    callback: (row) => {
                                        this.openUpdateModal(row, true, 4)
                                    },
                                    //permission:"cartoonanimationapplication_update"
                                },
                                {
                                    text: this.$t('delete'),
                                    class: 'ri-delete-bin-7-line align-middle top-minus-1 mr-3 text-muted',
                                    callback: (row) => {
                                        this.deleteApplication(row)
                                    },
                                    //permission:"cartoonanimationapplication_deletecartoonanimationapplication"
                                }
                            ]
                        },
                        {
                            label: this.$t('id'),
                            field: 'id',
                            hidden: false
                        },
                        {
                            label: this.$t('national_id'),
                            field: 'national_id',
                            hidden: false
                        },
                        {
                            label: this.$t('name'),
                            field: 'name',
                            hidden: false,
                        },
                        {
                            label: this.$t('surname'),
                            field: 'surname',
                            hidden: false
                        },
                        {
                            label: this.$t('high_school_name'),
                            field: 'high_school_name',
                            hidden: false,
                        },
                        {
                            label: this.$t('class'),
                            field: this.getLocaleField('class_name'),
                            hidden: false,
                        },
                        {
                            label: this.$t('semester'),
                            field: 'semester',
                            hidden: false,
                        },
                        {
                          label: this.$t('date'),
                          field: 'date',
                          hidden: false,
                        },
                        {
                            label: this.$t('status'),
                            field: this.getLocaleField('status_name'),
                            hidden: false
                        },
                        {
                            label: this.$t('group'),
                            field: 'group',
                            hidden: false
                        },
                        {
                            label: this.$t('interview_date'),
                            field: 'interview_date',
                            hidden: false
                        },
                        {
                            label: this.$t('interview_person'),
                            field: 'interview_person',
                            hidden: false
                        }
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                },
                updateData: {},
                updateTitle: null,
                updateMode: false,
                goTabIndex: 0,

                statusOptions: [
                    {
                        value: 'pending',
                        text: this.$t('pending')
                    },
                    {
                        value: 'accepted',
                        text: this.$t('accepted')
                    },
                    {
                        value: 'confirmed',
                        text: this.$t('confirmed')
                    },
                    {
                        value: 'archive',
                        text: this.$t('archive')
                    },
                    {
                        value: 'placed_to',
                        text: this.$t('placed_to')
                    }
                ],

                haveMessageOptions: [
                    {
                        value: 1,
                        text: this.$t('there_is')
                    },
                    {
                        value: '0',
                        text: this.$t('absent')
                    }
                ],

                bulkMsgForm: {},
                importModalTitle: '',
                importModalMode: null,
                importFile: null,
                groupOptions: [
                    {
                        value: 'pending',
                        text: this.$t('pending')
                    },
                    {
                        value: 'bisep',
                        text: this.$t('bisep'),
                    }
                ],
                paymentStatusOptions: [
                    {
                        value: 'E',
                        text: this.$t('yes')
                    },
                    {
                        value: 'H',
                        text: this.$t('no')
                    }
                ],

                highschoolClassOptions: [
                    { value: '11', text: '11' },
                    { value: '12', text: '12' },
                    { value: 'M', text: this.$t('alumni') },
                ],
            }
        },
        created() {
            this.filterSet();
            this.actions = [
                {
                    text: this.$t('exam_info_download'),
                    permission: 'cartoonanimationapplication_examinformationexcelexport',
                    callback: () => {
                        this.examInformationExcelExport()
                    }
                },
                {
                    text: this.$t('exam_info_upload'),
                    permission: 'cartoonanimationapplication_examinformationexcelimport',
                    callback: () => {
                        this.$bvModal.show('importFormModal');
                        this.importModalTitle = this.$t('exam_info_upload')
                        this.importModalMode = 'exam_info_upload'
                        this.importFile = null
                    }
                },
                {
                    text: this.$t('exam_result_download'),
                    permission: 'cartoonanimationapplication_examresultexcelexport',
                    callback: () => {
                        this.examResultExcelExport()
                    }
                },
                {
                    text: this.$t('exam_result_upload'),
                    permission: 'cartoonanimationapplication_examresultexcelimport',
                    callback: () => {
                        this.$bvModal.show('importFormModal')
                        this.importModalTitle = this.$t('exam_result_upload')
                        this.importModalMode = 'exam_result_upload'
                        this.importFile = null
                    }
                },
                {
                    text: this.$t('exam_result_calc'),
                    permission: 'cartoonanimationapplication_calculateexampoints',
                    callback: () => {
                        this.calculateExamPoints()
                    }
                }
            ]
        },

        methods: {
            formClear(){
              this.formProcess=null
            },
            filterSet() {
                this.datatable.queryParams.filter = {
                }
                this.nationalId = ''
            },
            filterClear() {
                this.filterSet()
                this.getRows();
            },
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            changeColumn(key) {
                this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field
                this.getRows();
            },

            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                if(this.nationalId){
                    this.datatable.queryParams.filter.national_id= this.nationalId.split('\n').filter(id =>id !=="");
                }
                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return BisepService.getAll(config).then(response => {
                    this.datatable.rows = response.data.data
                    this.datatable.total = response.data.pagination.total
                }).catch(e => {
                    this.showErrors(e)
                }).finally(() => {
                    this.datatable.isLoading = false;
                });
            },



            openUpdateModal(data, updateMode, goTab){
                this.updateMode = updateMode
                this.formProcess='updateModal'
                this.updateTitle = data.name+' '+data.surname
                this.formId = data.id
                this.goTabIndex = goTab
                this.$refs.updateModal.$refs.commonModal.show()
            },

            afterUpdate(){
                this.$refs.updateModal.$refs.commonModal.hide()
                this.getRows()
            },

            afterUpdateMsg(){
                this.getRows()
            },

            bulkMessage(){
                this.$refs.bulkMessageModal.$refs.commonModal.show()
            },

            async bulkMessageSend(){
                const isValid = await this.$refs.bulkMessageFormValidate.validate();
                if (isValid) {
                    let formData = {
                        filter: this.datatable.queryParams.filter,
                        ...this.bulkMsgForm
                    }
                    BisepService.bulkMessage(formData).then(response => {
                        this.$toast.success(this.$t('api.'+response.data.message))
                        this.$refs.bulkMessageModal.$refs.commonModal.hide()
                        this.bulkMsgForm = {}
                    }).catch(e => {
                        this.showErrors(e)
                    })
                }
            },

            examInformationExcelExport(){
                BisepService.examInformationExcelExport().then(response => {
                    this._downloadFile(response,this.$t('exam_info_download')+'.xlsx')
                }).catch(e => {
                    this.showErrors(e, null)
                })
            },

            async uploadFile(){
                const isValid = await this.$refs.importFormValidate.validate();
                if (isValid) {
                    if(this.importModalMode == 'exam_info_upload'){
                        let formData = new FormData()
                        formData.append('file', this.importFile);
                        BisepService.importExamInformationExcelImport(formData).then(response => {
                            this.$toast.success(this.$t('proccess_success'))
                            this.$bvModal.hide('importFormModal')
                            this.importModalMode = null
                        }).catch(e => {
                            this.showErrors(e, this.$refs.importFormValidate)
                        })
                    } else if(this.importModalMode == 'exam_result_upload'){
                        let formData = new FormData()
                        formData.append('file', this.importFile);
                        BisepService.importExamResultExcelImport(formData).then(response => {
                            this.$toast.success(this.$t('proccess_success'))
                            this.$bvModal.hide('importFormModal')
                            this.importModalMode = null
                        }).catch(e => {
                            this.showErrors(e, this.$refs.importFormValidate)
                        })
                    }
                }
            },

            examResultExcelExport(){
                BisepService.examResultExcelExport().then(response => {
                    this._downloadFile(response,this.$t('exam_result_download')+'.xlsx')
                }).catch(e => {
                    this.showErrors(e, null)
                })
            },

            calculateExamPoints(){
                BisepService.calculateExamPoints().then(response => {
                    this.$toast.success(this.$t('proccess_success'))
                }).catch(e => {
                    this.showErrors(e, null)
                })
            },

            excelExport(){
                if(this.datatable.queryParams.filter.national_id){
                    let nationalIds = this.datatable.queryParams.filter.national_id
                    if(typeof this.datatable.queryParams.filter.national_id == 'object'){
                        this.datatable.queryParams.filter.national_id = nationalIds.toString().split(`,`)
                    } else {
                        this.datatable.queryParams.filter.national_id = nationalIds.split(`\n`)
                    }
                }

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                }

                BisepService.applicationExcelExport(config).then(response => {
                    this._downloadFile(response, this.$t('results')+'.xlsx')
                }).catch(e => {
                    this.showErrors(e, null)
                })
            },

            deleteApplication(data){
                this.$swal.fire({
                        text: this.$t('are_you_sure_to_delete'),
                        showCancelButton: true,
                        confirmButtonText: this.$t('yes'),
                        cancelButtonText: this.$t('no'),
                        icon: 'question'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            BisepService.deleteApplication(data.id).then(response => {
                                this.$toast.success(this.$t('api.'+response.data.message))
                                this.getRows()
                            }).catch(e => {
                                this.showErrors(e, null)
                            })
                        }
                    })
            },

            downloadDocuments(){
                if(this.datatable.queryParams.filter.national_id){
                    let nationalIds = this.datatable.queryParams.filter.national_id
                    if(typeof this.datatable.queryParams.filter.national_id == 'object'){
                        this.datatable.queryParams.filter.national_id = nationalIds.toString().split(`,`)
                    } else {
                        this.datatable.queryParams.filter.national_id = nationalIds.split(`\n`)
                    }
                }

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                }

                BisepService.downloadDocumentsZip(config).then(response => {
                    this._downloadFile(response, this.$t('results')+'.zip')
                }).catch(e => {
                    this.showErrors(e, null)
                })
            },
            openAddModal(){
                this.formProcess='addModal'
                this.$refs.addModal.$refs.commonModal.show()
            }

        }
    }
</script>

